// CourseDropdownCard.jsx
import { Icon, Image } from '@blend-ed/blendx-ui';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import React, { useState } from 'react';
import placeholder from '../assets/images/placeholder.jpg';
import placeholderDark from '../assets/images/placeholder-dark.png';
import messages from './messages';

const CourseDropdownCard = ({ img, title, description, link, startDate, intl }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const isStartDateInFuture = new Date(startDate) > new Date();
    const startDateFormatted = startDate ? new Date(startDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : null;
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={`blendx-course-card ${isExpanded ? 'expanded' : ''}`}>
            <div className="course-header" onClick={toggleExpand}>
                <Image className="course-image" src={img} alt={intl.formatMessage(messages.courseImageAlt)} onError={(e) => {
                    e.target.src = isDarkMode ? placeholderDark : placeholder;
                }} />
                <Icon className="course-icon" icon="arrow-right-s" type="fill" />
                <span className="course-title">{title}</span>
            </div>
            <div className="course-content">
                <div className="content-wrapper">
                    <span className="content-description">{description}</span>
                    <span className="course-link-btn">
                        {isStartDateInFuture ? <span className="course-link-btn-text">{intl.formatMessage(messages.startDateInFuture, { startDate: startDateFormatted })}</span> :
                            <>
                                <a className="course-link" href={link}>{intl.formatMessage(messages.viewCourse)} </a>
                                <Icon className="course-link-icon" icon="arrow-right-up" type="line" />
                            </>
                        }
                    </span>
                </div>
            </div>
        </div>
    );
};

CourseDropdownCard.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CourseDropdownCard);